export default {
    library_categories: "Catégories",
    library_file_not_found: "Fichier de bibliothèque introuvable",
    loading_files: "Chargement de fichiers",
    no_files_are_available_at_the_moment: "Aucun fichier n'est actuellement disponible",
    no_files_are_available_with_the_selected_filter: "Aucun fichier disponible pour le filtre sélectionné"
}